import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M23.2402 41.87C23.2402 41.87 50.8702 27.42 52.2702 25.66C53.6702 23.9 54.6102 1 54.6102 1H76.6202C76.6202 1 77.5602 23.9 78.9602 25.66C80.3602 27.42 107.99 41.87 107.99 41.87C107.99 41.87 95.7402 56.92 65.6102 56.92C35.4802 56.92 23.2402 41.87 23.2402 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M9.52002 47.5699C12.6 43.9399 47.16 26.7599 47.16 26.7599L52.29 17.1799L65.62 38.7299L78.95 17.1799L84.08 26.7599C84.08 26.7599 118.64 43.9299 121.72 47.5699C124.8 51.1999 129.24 73.5499 129.24 73.5499H2C2 73.5499 6.44002 51.1999 9.52002 47.5699Z"
        fill="#B8E2E9"
        stroke="#63B1C3"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M102.62 36.76L96.3398 47.77L103.83 52.17L110.43 40.5L102.62 36.76Z" fill="#63B1C3" />
      <path d="M84.2303 27.98L81.0703 39.26L88.7703 43.55L94.6103 33.21L84.2303 27.98Z" fill="#113D56" />
      <path d="M94.6097 33.21L88.7197 43.53L96.4297 47.82L102.32 37.28L94.6097 33.21Z" fill="#156599" />
      <path d="M28.6596 36.76L34.9396 47.77L27.4496 52.17L20.8496 40.5L28.6596 36.76Z" fill="#63B1C3" />
      <path d="M47.0499 27.98L50.2099 39.26L42.5099 43.55L36.6699 33.21L47.0499 27.98Z" fill="#113D56" />
      <path d="M36.6697 33.21L42.5597 43.53L34.8597 47.82L28.9697 37.28L36.6697 33.21Z" fill="#156599" />
      <path
        d="M62.3205 67.9101V44.3101L54.7205 36.5901C54.7205 36.5901 24.0005 52.6001 22.3505 54.4101C20.7005 56.2301 17.7305 72.5101 17.7305 72.5101H113.73C113.73 72.5101 110.76 56.2301 109.11 54.4101C107.46 52.5901 76.7405 36.5901 76.7405 36.5901L68.2805 46.3301L69.1505 54.1701V67.9001H62.3205V67.9101Z"
        fill="white"
      />
      <path
        d="M70.71 31.06L79.9799 45.15L83.96 27.31L78.95 17.71L70.71 31.06Z"
        fill="#113D56"
        stroke="#63B1C3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M75.0097 38.5499L68.8197 47.4399C68.8197 47.4399 67.6597 42.2099 66.1797 39.6499L70.8597 32.1899L75.0097 38.5499Z"
        fill="#113D56"
      />
      <path
        d="M60.5701 31.06L51.3001 45.15L47.3301 27.31L52.3301 17.71L60.5701 31.06Z"
        fill="#113D56"
        stroke="#63B1C3"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M56.2695 38.5499L60.4295 32.1899L64.5095 37.7499C64.5095 37.7499 69.1295 44.3599 69.1295 52.4999C69.1295 60.6499 69.1295 67.9099 69.1295 67.9099H62.3295C62.3295 67.9099 62.3295 59.0199 62.3295 52.6499C62.3295 46.2799 56.2695 38.5499 56.2695 38.5499Z"
        fill="#113D56"
      />
      <path
        d="M65.6099 64.3199C66.2892 64.3199 66.8399 63.7692 66.8399 63.0899C66.8399 62.4106 66.2892 61.8599 65.6099 61.8599C64.9306 61.8599 64.3799 62.4106 64.3799 63.0899C64.3799 63.7692 64.9306 64.3199 65.6099 64.3199Z"
        fill="#63B1C3"
      />
      <path
        d="M65.6099 54.0801C66.2892 54.0801 66.8399 53.5294 66.8399 52.8501C66.8399 52.1708 66.2892 51.6201 65.6099 51.6201C64.9306 51.6201 64.3799 52.1708 64.3799 52.8501C64.3799 53.5294 64.9306 54.0801 65.6099 54.0801Z"
        fill="#63B1C3"
      />
      <path
        d="M61.0403 30.97C62.3603 32.64 63.4904 34.36 64.5804 36.14C65.6504 37.92 66.6104 39.78 67.4004 41.71C68.1804 43.65 68.7303 45.6799 69.0903 47.7299C69.4103 49.7899 69.4204 51.9 69.1204 53.94C69.0004 51.88 68.7103 49.88 68.1903 47.93C67.6503 45.99 66.9504 44.0999 66.1404 42.2599C65.3104 40.4299 64.3903 38.63 63.3403 36.9C62.3003 35.18 61.1304 33.49 59.8604 31.99L61.0403 30.97Z"
        fill="#63B1C3"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6117"
          y1="35.04"
          x2="65.6117"
          y2="24.2038"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
